import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Chip from '@material-ui/core/Chip';
import classNames from 'classnames';
import { keyEmptyCheck } from 'aurora-utils/utils';
import styles from './styles';

function StatusChip(props) {
  const { classes, status } = props;

  switch (status?.toUpperCase()) {
    case 'EXPIRED':
      return (
        <Chip
          label={keyEmptyCheck(status?.toLowerCase())}
          className={classNames(classes.greyChip, classes.initibadges)}
        />
      );

    case 'DISCHARGED':
    case 'REJECTED':
    case 'CLOSED':
    case 'CANCELLED':
    case 'TERMINATED':
      return (
        <Chip
          label={keyEmptyCheck(status?.toLowerCase())}
          className={classNames(classes.redChip, classes.initibadges)}
        />
      );

    case 'ACTIVE':
    case 'COMPLETED':
      return <Chip label={keyEmptyCheck('Active')} className={classNames(classes.greenChip, classes.initibadges)} />;

    case 'Construction':
      return (
        <Chip
          label={keyEmptyCheck('under_construction')}
          className={classNames(classes.orangeChip, classes.initibadges)}
        />
      );
    default:
      return (
        <Chip
          label={keyEmptyCheck(status?.toLowerCase())}
          className={classNames(classes.greenChip, classes.initibadges)}
        />
      );
  }
}

StatusChip.propTypes = {
  classes: PropTypes.object.isRequired,
  status: PropTypes.string.isRequired,
};

export default withStyles(styles)(StatusChip);
